import { TFilterValue } from '../accordionFilter/models/IAccordionFilters'

export const prepareValueForMultiselect = (value: TFilterValue) => {
  if (!value) {
    return []
  }

  return Array.isArray(value) ? (value as string[]) : [`${value}`]
}
